/// <reference path='../_all.ts' />

module part {
  'use strict';


  export class Price {
    constructor(
      public ValidFrom: Date,
      public ValidTo: Date,
      public Value: number,
      public Staffelung: number,
      public IsAufAnfrage: boolean,
      public ShowPriceDateFrom: boolean,
      public ShowPriceDateTo: boolean
    ) { }
  }
}